var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"icon-button",attrs:{"type":_vm.type}},_vm.$listeners),[_c(_vm.icon,{tag:"component",staticClass:"icon-button__icon",style:({ height: _vm.height })})],1)}
var staticRenderFns = []

export { render, staticRenderFns }